﻿export default class PersonalDataTypeDiv extends HTMLDivElement {
    constructor() {
        super();
    }

    get personalTypeSelect() {
        return this.querySelector("[data-personaldatattype-input='select']");
    }

    get personalTypeEditInput() {
        return this.querySelector("[data-personaldatattype-input='edit-input']");
    }

    get personalTypeDeleteInput() {
        return this.querySelector("[data-personaldatattype-input='delete-input']");
    }

    get extractHelpText() {
        return this.querySelector("[data-personaldatattype-helptext='extract']");
    }

    get editHelpText() {
        return this.querySelector("[data-personaldatattype-helptext='edit']");
    }

    get deleteHelpText() {
        return this.querySelector("[data-personaldatattype-helptext='delete']");
    }

    showHelpText(id) {
        if (id === '1') {
            this.extractHelpText.classList.remove("hidden");
            this.editHelpText.classList.add("hidden");
            this.deleteHelpText.classList.add("hidden");
            this.personalTypeEditInput.classList.add("hidden");
            this.personalTypeDeleteInput.classList.add("hidden");
        }
        else if (id === '2') {
            this.editHelpText.classList.remove("hidden");
            this.extractHelpText.classList.add("hidden");
            this.deleteHelpText.classList.add("hidden");
            this.personalTypeEditInput.classList.remove("hidden");
            this.personalTypeDeleteInput.classList.add("hidden");
        }
        else if (id === '3') {
            this.deleteHelpText.classList.remove("hidden");
            this.extractHelpText.classList.add("hidden");
            this.editHelpText.classList.add("hidden");
            this.personalTypeEditInput.classList.add("hidden");
            this.personalTypeDeleteInput.classList.remove("hidden");
        }
    }

    connectedCallback() {
        console.log(this.personalTypeSelect);
        this.personalTypeSelect.addEventListener('change', e => {
            this.showHelpText(e.target.value);
        });
    }

    disconnectedCallback() {
        this.personalTypeSelect().removeEventListener('change');
    }

}

customElements.define("personaldata-type", PersonalDataTypeDiv, { extends: "div" });